/** Mirrors conversations/leads/services/portal_lead_webhook_fields.PORTAL_LEAD_WEBHOOK_FIELDS */
export type PortalLeadWebhookField = {
  key: string
  label: string
  source: string
}

export const PORTAL_LEAD_WEBHOOK_FIELDS: PortalLeadWebhookField[] = [
  { key: 'lead_name', label: 'Nombre completo', source: 'Nombre + Apellidos' },
  { key: 'first_name', label: 'Nombre', source: 'Nombre' },
  { key: 'last_name', label: 'Apellidos', source: 'Apellidos' },
  { key: 'email', label: 'Email', source: 'Email' },
  { key: 'mobile', label: 'Móvil', source: 'Movil' },
  { key: 'portal', label: 'Portal', source: 'Portal' },
  { key: 'property_id', label: 'ID inmueble', source: 'IdInmueble' },
  {
    key: 'property_ref',
    label: 'Referencia inmueble',
    source: 'Ref_CRM (iagestión, vía IdInmueble)',
  },
  { key: 'lead_id', label: 'ID lead', source: 'IdLead' },
  { key: 'contact_id', label: 'ID contacto', source: 'id_contacto / IdUsuario' },
  { key: 'agent_id', label: 'ID gestor', source: 'AgenteGestor' },
  { key: 'notes', label: 'Notas', source: 'Notas' },
  { key: 'agency_id', label: 'ID agencia', source: 'IdAgencia' },
]

const PORTAL_LEAD_FIELD_EXAMPLES: Record<string, string> = {
  lead_name: 'Mounir Nasraou',
  portal: 'idealista',
  mobile: '+34600111222',
  email: 'lead@example.com',
  property_ref: '2502',
}

export function portalLeadWebhookFieldExample(key: string): string | undefined {
  return PORTAL_LEAD_FIELD_EXAMPLES[key]
}
